import React, { useEffect, useState } from "react";
import Page from "./Page";
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HelpCenter.scss"; // Assuming you have a CSS file for styling
import SessionRequest from "../components/home/SessionRequest";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useTranslation } from "react-i18next";
function HelpCenter() {
  const { t } = useTranslation();
  return (
    <Page>
      <div className="help-center">
        <div className="icon mb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="64"
            height="64"
            fill="rgba(0,0,0,1)"
          >
            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"></path>
          </svg>
        </div>
        <h1>Need Help?</h1>
        <p>
          Our team is here to support you. If you experience any technical
          issues or have any questions, simply reach out to us by email.
        </p>

        <div className="contact-box">
          <p>
            <strong>Email us at:</strong>
          </p>
          <a href="mailto:us_financial.coaching@pwc.com">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 
          2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 
          2-2zm0 2v.01L12 13l8-6.99V6H4zm0 
          12h16V8l-8 6-8-6v10z"
              />
            </svg>
            us_financial.coaching@pwc.com
          </a>
        </div>

        <p>
          {t(
            "we’ll_get_back_to_you_as_quickly_as_possible_to_make_sure_you_can_continue_your_financial_wellness_journey",
          )}
        </p>
      </div>
    </Page>
  );
}

export default HelpCenter;
